var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { action, observable, computed, runInAction, reaction } from 'mobx';
import { isNil, flatten, defer } from 'lodash';
import { FloorPlanEditState, UserType, isAssignedOwner, isAssignedTo, } from '../types/floorplan';
import { getSpaceByTag, getTableByTag, getSpaceByTable, getTableByLetter } from '../utils/mark-utils';
import API from '../utils/api';
import constants from '../utils/constants';
import { isArray } from 'util';
import { SpaceTagToMarker, TableTagToMarker, parseLayout, parseAssigns, moveToWritableMove, } from '../utils/typeConversions';
import { localeByIso } from '../i18n';
var FloorPlanStore = /** @class */ (function () {
    function FloorPlanStore() {
        var _this = this;
        // --------------------------------------------------------------------------
        this.userType = UserType.RPM;
        this.editState = FloorPlanEditState.Upload;
        this.move = {
            name: '',
            company: {
                name: '',
            },
            path: '',
            generalInfos: [],
            locale: localeByIso(constants.PREFERRED_LANGUAGE_ISO).backend,
            stickersNumber: 0,
        };
        this.floors = [];
        this.currentFloor = null;
        this.owners = [];
        // Currently selected space for connecting owners.
        this.spaceSelection = null;
        // TODO: Correct types missing:
        this.moveKeyInfo = [];
        this.contactInfo = [];
        this.moveId = undefined;
        this.accessToken = undefined;
        // ---------AUTOMATIC SIDE-EFFECTS--------
        this.initializeSideEffects = function () {
            reaction(function () { return _this.unAssignedOwners; }, function (unAssignedOwners) {
                if (_this.unassignedPeopleAlreadyFetched && _this.moveId) {
                    var moveId_1 = _this.moveId;
                    _this.serializedCall(function () { return API.saveUnassignedOwners(moveId_1, unAssignedOwners); });
                }
            });
        };
        this.fetchMove = function (moveId) { return __awaiter(_this, void 0, void 0, function () {
            var move;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.serializedCall(function () { return API.getMove(moveId); })];
                    case 1:
                        move = _a.sent();
                        this.move = move;
                        this.moveKeyInfo = move.generalInfos;
                        this.fetchUnassignedPeople();
                        return [2 /*return*/];
                }
            });
        }); };
        this.unassignedPeopleAlreadyFetched = false;
        this.fetchUnassignedPeople = function () { return __awaiter(_this, void 0, void 0, function () {
            var moveId, people, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        moveId = this.moveId;
                        if (!(!this.unassignedPeopleAlreadyFetched && moveId)) return [3 /*break*/, 4];
                        this.unassignedPeopleAlreadyFetched = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.serializedCall(function () { return API.getUnassignedOwners(moveId); })];
                    case 2:
                        people = _a.sent();
                        this.createOwner(people);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        this.unassignedPeopleAlreadyFetched = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.setEditState = function (state) {
            _this.editState = state;
        };
        this.setStickersNumberForMove = function (stickersNumber) {
            var moveId = _this.moveId;
            if (moveId != null) {
                _this.move.stickersNumber = stickersNumber;
                var writableMove_1 = moveToWritableMove(_this.move);
                _this.serializedCall(function () { return API.saveMove(moveId, writableMove_1); });
            }
        };
        this.setCurrentFloor = function (floor) {
            _this.currentFloor = floor;
        };
        this.setCurrentFloorBasedOnUrlParam = function (floorIdStr) {
            var floor = _this.floors.find(function (floor) { return floor.id === floorIdStr; });
            if (floor && floor !== _this.currentFloor) {
                runInAction(function () {
                    _this.setCurrentFloor(floor);
                });
            }
        };
        // Add new space marker.
        this.addSpace = function (tag) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isNil(this.currentFloor)) {
                            return [2 /*return*/];
                        }
                        if (this.currentFloor.spaces.includes(tag)) {
                            return [2 /*return*/];
                        }
                        this.currentFloor.spaces.push(tag);
                        return [4 /*yield*/, this.saveNewSpaceTag(tag)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        // Add new table marker.
        this.addTable = function (tag) {
            if (isNil(_this.currentFloor)) {
                return;
            }
            var currentSpace = getSpaceByTable(_this.currentFloor, tag);
            if (currentSpace) {
                if (currentSpace.tables.includes(tag)) {
                    return;
                }
                currentSpace.tables.push(tag);
            }
            _this.saveNewTableTag(tag);
        };
        // Edit space title or openSpace value of space marker.
        this.editSpace = function (tag, title, openSpace) { return __awaiter(_this, void 0, void 0, function () {
            var index, currentFloor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isNil(this.currentFloor)) {
                            return [2 /*return*/];
                        }
                        index = this.currentFloor.spaces.findIndex(function (space) {
                            return space === tag;
                        });
                        if (index > -1) {
                            this.currentFloor.spaces[index].title = title;
                            this.currentFloor.spaces[index].openSpace = openSpace;
                        }
                        currentFloor = this.currentFloor;
                        return [4 /*yield*/, this.serializedCall(function () { return API.updateMarker(SpaceTagToMarker(tag, currentFloor)); })];
                    case 1:
                        _a.sent();
                        if (!isNil(this.currentFloor)) {
                            this.refreshSingleLayout(this.currentFloor.id);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        // Edit space or letter value of table marker.
        // Changing space removes old table marker and creates a new one with same xy-position.
        this.editTable = function (tag, spaceTitle, letter) { return __awaiter(_this, void 0, void 0, function () {
            var currentSpace, currentTable_1, currentFloor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isNil(this.currentFloor)) {
                            return [2 /*return*/];
                        }
                        currentSpace = getSpaceByTable(this.currentFloor, tag);
                        if (currentSpace) {
                            currentTable_1 = getTableByTag(currentSpace, tag);
                            if (currentTable_1) {
                                // To edit only letter:
                                if (tag.space === spaceTitle) {
                                    currentTable_1.letter = letter;
                                }
                                else {
                                    // Remove tag from previous space & add new one.
                                    currentSpace.tables = currentSpace.tables.filter(function (table) { return table !== currentTable_1; });
                                    this.addTable({
                                        space: spaceTitle,
                                        letter: letter,
                                        positionX: tag.positionX,
                                        positionY: tag.positionY,
                                    });
                                }
                            }
                        }
                        currentFloor = this.currentFloor;
                        return [4 /*yield*/, this.serializedCall(function () { return API.updateMarker(TableTagToMarker(tag, currentFloor)); })];
                    case 1:
                        _a.sent();
                        if (!isNil(this.currentFloor)) {
                            this.refreshSingleLayout(this.currentFloor.id);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        // Remove space from current floor. + Remove owners including this space from assignedOwners.
        this.removeSpace = function (tag) { return __awaiter(_this, void 0, void 0, function () {
            var currentSpace, id_1, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isNil(this.currentFloor)) {
                            return [2 /*return*/];
                        }
                        currentSpace = getSpaceByTag(this.currentFloor, tag);
                        if (currentSpace) {
                            this.currentFloor.spaces = this.currentFloor.spaces.filter(function (space) { return space !== currentSpace; });
                        }
                        this.owners.forEach(function (owner) {
                            if (owner.space === currentSpace) {
                                owner.floor = null;
                                owner.space = null;
                                owner.table = null;
                            }
                        });
                        if (!!isNil(tag.id)) return [3 /*break*/, 2];
                        id_1 = tag.id;
                        return [4 /*yield*/, this.serializedCall(function () { return API.removeMarker(id_1); })];
                    case 1:
                        response = _a.sent();
                        console.dir(response);
                        _a.label = 2;
                    case 2:
                        if (!isNil(this.currentFloor)) {
                            this.refreshSingleLayout(this.currentFloor.id);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        // TODO: Before calling, alert user in case table includes an owner.
        this.removeTable = function (tag) { return __awaiter(_this, void 0, void 0, function () {
            var currentSpace, currentTable, id_2, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isNil(this.currentFloor)) {
                            return [2 /*return*/];
                        }
                        currentSpace = getSpaceByTable(this.currentFloor, tag);
                        if (!currentSpace) {
                            return [2 /*return*/];
                        }
                        currentTable = getTableByTag(currentSpace, tag);
                        currentSpace.tables = currentSpace.tables.filter(function (table) { return table !== currentTable; });
                        this.owners.forEach(function (owner) {
                            if (owner.floor === _this.currentFloor && owner.space === currentSpace && owner.table === currentTable) {
                                owner.table = null;
                            }
                        });
                        if (!!isNil(tag.id)) return [3 /*break*/, 2];
                        id_2 = tag.id;
                        return [4 /*yield*/, this.serializedCall(function () { return API.removeMarker(id_2); })];
                    case 1:
                        response = _a.sent();
                        console.dir(response);
                        _a.label = 2;
                    case 2:
                        if (!isNil(this.currentFloor)) {
                            this.refreshSingleLayout(this.currentFloor.id);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        // Defines currently selected space for connecting owners.
        this.setSpaceSelection = function (tag) {
            _this.spaceSelection = tag;
        };
        // --------OWNER RELATED ACTIONS-----------
        this.createSingleOwner = function (ownerName) {
            return {
                key: Math.random().toString(36).substring(7),
                name: ownerName,
                stickersNumber: null,
                floor: null,
                space: null,
                table: null,
            };
        };
        // Add new unassigned owner.
        this.createOwner = function (arg) {
            var ownersNames;
            isArray(arg) ? (ownersNames = arg) : (ownersNames = [arg]);
            var newOwners = ownersNames.map(function (ownerName) { return _this.createSingleOwner(ownerName); });
            _this.owners = _this.owners.concat(newOwners);
        };
        this.importAssignments = function (assignments) { return __awaiter(_this, void 0, void 0, function () {
            var getName, makeSpaceWithOptionalTable;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // First return all existing owners
                    return [4 /*yield*/, Promise.all(this.assignedOwners.map(function (o) { return _this.returnOwner(o); }))];
                    case 1:
                        // First return all existing owners
                        _a.sent();
                        // Clear unassigned owners
                        runInAction(function () {
                            _this.owners = [];
                        });
                        return [4 /*yield*/, this.serializedCall(function () { return API.saveUnassignedOwners(_this.moveId, _this.unAssignedOwners); })];
                    case 2:
                        _a.sent();
                        getName = function (space, table) {
                            var name = ((space === null || space === void 0 ? void 0 : space.title) + ' ' + ((table === null || table === void 0 ? void 0 : table.letter) || '')).trimEnd();
                            return name;
                        };
                        makeSpaceWithOptionalTable = function (floor, space, table) { return ({
                            floor: floor,
                            space: space,
                            table: table,
                        }); };
                        return [4 /*yield*/, Promise.all(assignments
                                .split('\n')
                                .filter(function (_, i) { return i > 0; })
                                .map(function (line) { return line.split(';'); })
                                .filter(function (line) { return line[1] && line[1].length > 0; })
                                .map(function (components) { return __awaiter(_this, void 0, void 0, function () {
                                var newOwner, matchingSpacesOrTables, matchingSpaceOrTable, saveOwnerResponse, updateMarkerResponse;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            newOwner = this.createSingleOwner(components[1]);
                                            matchingSpacesOrTables = this.floors.flatMap(function (f) {
                                                return f.spaces
                                                    .flatMap(function (s) {
                                                    return s.tables
                                                        .map(function (t) { return makeSpaceWithOptionalTable(f, s, t); })
                                                        .concat([makeSpaceWithOptionalTable(f, s, null)]);
                                                })
                                                    .filter(function (t) { return getName(t.space, t.table) == components[0].trim(); });
                                            });
                                            if (!(matchingSpacesOrTables && matchingSpacesOrTables.length > 0)) return [3 /*break*/, 3];
                                            matchingSpaceOrTable = matchingSpacesOrTables[0];
                                            newOwner.floor = matchingSpaceOrTable.floor;
                                            newOwner.space = matchingSpaceOrTable.space;
                                            newOwner.table = matchingSpaceOrTable.table;
                                            return [4 /*yield*/, this.serializedCall(function () {
                                                    return API.saveNewOwner(newOwner.space.id, newOwner.name);
                                                })];
                                        case 1:
                                            saveOwnerResponse = _a.sent();
                                            if (saveOwnerResponse && saveOwnerResponse.data && saveOwnerResponse.data.id) {
                                                newOwner.id = saveOwnerResponse.data.id;
                                                newOwner.key = saveOwnerResponse.data.id;
                                            }
                                            if (!newOwner.table) return [3 /*break*/, 3];
                                            return [4 /*yield*/, this.serializedCall(function () { return API.updateMarkerOwner(newOwner); })];
                                        case 2:
                                            updateMarkerResponse = _a.sent();
                                            if (updateMarkerResponse && updateMarkerResponse.data && updateMarkerResponse.data.id) {
                                                newOwner.id = updateMarkerResponse.data.id;
                                                newOwner.key = updateMarkerResponse.data.id;
                                            }
                                            _a.label = 3;
                                        case 3:
                                            runInAction(function () {
                                                _this.owners = _this.owners.concat([newOwner]);
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        // Assign owner to some space.
        this.assignOwner = function (owner, tag) { return __awaiter(_this, void 0, void 0, function () {
            var currentSpace, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.currentFloor) {
                            return [2 /*return*/];
                        }
                        currentSpace = getSpaceByTag(this.currentFloor, tag);
                        this.setSpaceSelection(currentSpace);
                        owner.floor = this.currentFloor;
                        owner.space = tag;
                        owner.table = null;
                        if (!(currentSpace && currentSpace.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.serializedCall(function () { return API.saveNewOwner(currentSpace.id, owner.name); })];
                    case 1:
                        response = _a.sent();
                        if (response.data.id) {
                            owner.id = response.data.id;
                            owner.key = response.data.id;
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        // Rename assigned owner
        this.renameOwner = function (owner, space) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.serializedCall(function () { return API.deleteMarkerOwner(owner.id); })];
                    case 1:
                        _a.sent();
                        if (!(space === null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.serializedCall(function () { return API.saveUnassignedOwners(_this.moveId, _this.unAssignedOwners); })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.serializedCall(function () { return API.saveNewOwner(space.id, owner.name); })];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.assignOwnerWithName = function (owner, spaceName) {
            if (!_this.currentFloor) {
                return;
            }
            var space = _this.currentFloor.spaces.find(function (space) { return space.title === spaceName; });
            if (space) {
                _this.assignOwner(owner, space);
            }
        };
        // Assign owner to some table. Owner already has a Space.
        this.assignOwnerTable = function (owner, tableLetter) { return __awaiter(_this, void 0, void 0, function () {
            var currentTable, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!owner || !owner.space) {
                            return [2 /*return*/];
                        }
                        currentTable = getTableByLetter(owner.space, tableLetter);
                        owner.table = currentTable;
                        return [4 /*yield*/, this.serializedCall(function () { return API.updateMarkerOwner(owner); })];
                    case 1:
                        response = _a.sent();
                        if (response && response.data && response.data.id) {
                            owner.id = response.data.id;
                            owner.key = response.data.id;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        // Add new unassigned owner.
        this.setStickersNumberForOwner = function (ownerKey, stickersNumber) { return __awaiter(_this, void 0, void 0, function () {
            var owner;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        owner = this.owners.find(function (o) { return o.key === ownerKey; });
                        if (!owner || (stickersNumber !== null && isNaN(stickersNumber))) {
                            return [2 /*return*/];
                        }
                        owner.stickersNumber = stickersNumber;
                        return [4 /*yield*/, this.serializedCall(function () { return API.updateMarkerOwner(owner); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        // Return once assigned owner back to unassigned.
        this.returnOwner = function (owner) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.serializedCall(function () { return API.deleteMarkerOwner(owner.id); }).then(action(function () {
                            owner.floor = null;
                            owner.space = null;
                            owner.table = null;
                        }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        // Remove an owner from unassignedOwners list. When deleting OR assigning.
        this.deleteOwner = function (owner) {
            var index = _this.owners.indexOf(owner);
            if (index >= 0) {
                _this.owners.splice(index, 1);
            }
        };
        this.saveNewLayout = function (floorName, file, labelColor, floorSize, isDefault) { return __awaiter(_this, void 0, void 0, function () {
            var moveId, defaultFloor, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        moveId = this.moveId;
                        if (!moveId) return [3 /*break*/, 5];
                        if (!isDefault) return [3 /*break*/, 2];
                        defaultFloor = this.floors.find(function (floor) { return floor.isDefault; });
                        if (!defaultFloor) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateFloor(defaultFloor.id, {
                                label_color: defaultFloor.labelColor,
                                isDefault: false,
                                floor_name: defaultFloor.title,
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.serializedCall(function () {
                            return API.postNewLayout(moveId, floorName, file, labelColor, floorSize, isDefault);
                        })];
                    case 3:
                        response = _a.sent();
                        return [4 /*yield*/, this.refreshLayouts()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, response];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.deleteLayout = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.moveId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.serializedCall(function () { return API.deleteLayout(id); })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.refreshLayouts()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, response];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.refreshLayouts = function () { return __awaiter(_this, void 0, void 0, function () {
            var moveId, layouts, allLayouts, parsedFloors_1, refreshedListOfAssignedOwners_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        moveId = this.moveId;
                        if (!moveId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.serializedCall(function () { return API.getAllLayouts(moveId); })];
                    case 1:
                        layouts = _a.sent();
                        return [4 /*yield*/, Promise.all(layouts.map(function (layout) {
                                return _this.serializedCall(function () { return API.getLayoutData(moveId, layout.id); });
                            }))];
                    case 2:
                        allLayouts = _a.sent();
                        parsedFloors_1 = allLayouts.map(parseLayout);
                        refreshedListOfAssignedOwners_1 = flatten(allLayouts.map(function (layout, i) { return parseAssigns(layout, parsedFloors_1[i]); }));
                        runInAction(function () {
                            _this.floors = parsedFloors_1.sort(function (a, b) { return parseInt(b.title) - parseInt(a.title); });
                            /*
                            refreshedListOfAssignedOwners includes only owners that have been assigned
                            to a space or a table at the moment (only spaces and tables are part of a
                            *layout*. However, we might have some unassigned owners as well (because
                            those come from a separate API endpoint, or because user has already added
                            some more in the UI). Because of this we need to preserve those,
                            even though we "replace" the assigned ones with the ones that came from
                            backend
                          */
                            _this.owners = _this.unAssignedOwners.concat(refreshedListOfAssignedOwners_1);
                            // Default: Choose the first floor in the array
                            var nextFloor = _this.floors && _this.floors[0];
                            var defaultFloor = _this.floors.find(function (f) { return f.isDefault; });
                            if (defaultFloor)
                                nextFloor = defaultFloor;
                            // But if there was already a current floor, try to
                            // find a similar one from the new array
                            var id = _this.currentFloor && _this.currentFloor.id;
                            if (id) {
                                var similarFloor = _this.floors.find(function (f) { return f.id === id; });
                                if (similarFloor) {
                                    nextFloor = similarFloor;
                                }
                            }
                            if (nextFloor) {
                                _this.setCurrentFloor(nextFloor);
                            }
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.refreshSingleLayout = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var moveId, layoutData, parsedLayout_1, floorIndex_1, refreshedListOfAssignedOwners_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        moveId = this.moveId;
                        if (!moveId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.serializedCall(function () { return API.getLayoutData(moveId, id); })];
                    case 1:
                        layoutData = _a.sent();
                        parsedLayout_1 = parseLayout(layoutData);
                        floorIndex_1 = this.floors.findIndex(function (floor) { return floor.id === id; });
                        refreshedListOfAssignedOwners_2 = parseAssigns(layoutData, this.floors[floorIndex_1]);
                        runInAction(function () {
                            // Set layout data in this.floors
                            _this.floors[floorIndex_1] = parsedLayout_1;
                            // Set current floor
                            _this.currentFloor = _this.floors[floorIndex_1];
                            /*
                                refreshedListOfAssignedOwners includes only owners that have been assigned
                                to a space or a table at the moment (only spaces and tables are part of a
                                *layout*. However, we might have some unassigned owners as well (because
                                those come from a separate API endpoint, or because user has already added
                                some more in the UI). Because of this we need to preserve those,
                                even though we "replace" the assigned ones with the ones that came from
                                backend
                              */
                            _this.owners = _this.unAssignedOwners.concat(refreshedListOfAssignedOwners_2);
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.saveNewSpaceTag = function (tag) { return __awaiter(_this, void 0, void 0, function () {
            var floor, marker_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        floor = this.currentFloor;
                        if (!!isNil(floor)) return [3 /*break*/, 3];
                        marker_1 = SpaceTagToMarker(tag, floor);
                        return [4 /*yield*/, this.serializedCall(function () { return API.postNewMarker(marker_1); })];
                    case 1:
                        _a.sent();
                        if (!!isNil(this.currentFloor)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.refreshSingleLayout(this.currentFloor.id)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.saveNewTableTag = function (tag) { return __awaiter(_this, void 0, void 0, function () {
            var floor, marker_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        floor = this.currentFloor;
                        if (!!isNil(floor)) return [3 /*break*/, 2];
                        marker_2 = TableTagToMarker(tag, floor);
                        return [4 /*yield*/, this.serializedCall(function () { return API.postNewMarker(marker_2); })];
                    case 1:
                        _a.sent();
                        if (!isNil(this.currentFloor)) {
                            this.refreshSingleLayout(this.currentFloor.id);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.serializingPromise = Promise.resolve(0);
        defer(this.initializeSideEffects);
    }
    Object.defineProperty(FloorPlanStore.prototype, "companyName", {
        // ----------------COMPUTED----------------
        get: function () {
            return this.move.company.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FloorPlanStore.prototype, "floorNames", {
        get: function () {
            var floorNames = [];
            this.floors.forEach(function (floor) { return floorNames.push(floor.title); });
            return floorNames;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FloorPlanStore.prototype, "tableTags", {
        // Returns all saved table markers belonging to current floor.
        get: function () {
            if (isNil(this.currentFloor)) {
                return [];
            }
            var tags = [];
            this.currentFloor.spaces.forEach(function (space) {
                space.tables.forEach(function (tag) {
                    tags.push(tag);
                });
            });
            return tags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FloorPlanStore.prototype, "assignedOwners", {
        get: function () {
            return this.owners.filter(isAssignedOwner);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FloorPlanStore.prototype, "unAssignedOwners", {
        get: function () {
            return this.owners.filter(function (o) { return !isAssignedOwner(o); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FloorPlanStore.prototype, "spaceAssignedOwners", {
        get: function () {
            var _this = this;
            return this.owners.filter(function (o) { return _this.spaceSelection && isAssignedTo(o, _this.spaceSelection); });
        },
        enumerable: true,
        configurable: true
    });
    // ----------------ACTIONS----------------
    FloorPlanStore.prototype.setAccessToken = function (accessToken) {
        this.accessToken = accessToken;
        API.setAccessToken(accessToken);
    };
    FloorPlanStore.prototype.updateFloor = function (floorId, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var foundFloor, defaultFloor, updatedFloorWithTheSameId, floorWithTheSameId, updatedFloorResponse;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        foundFloor = this.floors.find(function (floor) { return floor.id === floorId; });
                        if (!foundFloor) {
                            return [2 /*return*/];
                        }
                        this.updatingFloor = foundFloor;
                        if (!payload.isDefault) return [3 /*break*/, 2];
                        defaultFloor = this.floors.find(function (floor) { return floor.isDefault; });
                        if (!(defaultFloor && defaultFloor.id !== floorId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateFloor(defaultFloor.id, {
                                label_color: defaultFloor.labelColor,
                                isDefault: false,
                                floor_name: defaultFloor.title,
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        floorWithTheSameId = this.floors.find(function (floor) { return floor.title === payload.floor_name && floor.id !== floorId; });
                        return [4 /*yield*/, this.serializedCall(function () { return API.updateFloor(floorId, payload); })];
                    case 3:
                        updatedFloorResponse = _a.sent();
                        if (!floorWithTheSameId) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.serializedCall(function () {
                                return API.updateFloor(floorWithTheSameId.id, {
                                    label_color: floorWithTheSameId.labelColor,
                                    isDefault: floorWithTheSameId.isDefault,
                                    floor_name: foundFloor.title,
                                });
                            })];
                    case 4:
                        updatedFloorWithTheSameId = _a.sent();
                        _a.label = 5;
                    case 5:
                        runInAction(function () {
                            // update the list of floors
                            _this.floors = _this.floors.map(function (floor) {
                                if (floor.id === updatedFloorResponse.id) {
                                    return __assign(__assign({}, floor), { labelColor: updatedFloorResponse.label_color, isDefault: updatedFloorResponse.isDefault, title: updatedFloorResponse.floor_name });
                                }
                                if (floorWithTheSameId && floor.id === updatedFloorWithTheSameId.id) {
                                    return __assign(__assign({}, floor), { labelColor: updatedFloorWithTheSameId.label_color, isDefault: updatedFloorWithTheSameId.isDefault, title: updatedFloorWithTheSameId.floor_name });
                                }
                                return floor;
                            });
                            _this.floors = _this.floors.sort(function (a, b) { return parseInt(b.title) - parseInt(a.title); });
                            // unset updatingFloor, since we're not updating anymore
                            _this.updatingFloor = undefined;
                            var updatedFloor = _this.floors.find(function (floor) { return floor.id === floorId; });
                            // update floor reference in owners list
                            _this.owners = _this.owners.map(function (owner) {
                                if (owner.floor && owner.floor.id === floorId && updatedFloor) {
                                    owner.floor = __assign({}, updatedFloor);
                                    return owner;
                                }
                                return owner;
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    FloorPlanStore.prototype.serializedCall = function (action) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.serializingPromise = _this.serializingPromise.then(function (_) {
                return action()
                    .then(function (value) { return resolve(value); })
                    .catch(function (error) { return reject(error); });
            });
        });
    };
    __decorate([
        observable
    ], FloorPlanStore.prototype, "userType", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "editState", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "move", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "floors", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "updatingFloor", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "currentFloor", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "owners", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "spaceSelection", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "moveKeyInfo", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "contactInfo", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "moveId", void 0);
    __decorate([
        observable
    ], FloorPlanStore.prototype, "accessToken", void 0);
    __decorate([
        computed
    ], FloorPlanStore.prototype, "companyName", null);
    __decorate([
        computed
    ], FloorPlanStore.prototype, "floorNames", null);
    __decorate([
        computed
    ], FloorPlanStore.prototype, "tableTags", null);
    __decorate([
        computed
    ], FloorPlanStore.prototype, "assignedOwners", null);
    __decorate([
        computed
    ], FloorPlanStore.prototype, "unAssignedOwners", null);
    __decorate([
        computed
    ], FloorPlanStore.prototype, "spaceAssignedOwners", null);
    __decorate([
        action
    ], FloorPlanStore.prototype, "setAccessToken", null);
    __decorate([
        action
    ], FloorPlanStore.prototype, "fetchMove", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "setEditState", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "setStickersNumberForMove", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "setCurrentFloor", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "setCurrentFloorBasedOnUrlParam", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "addSpace", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "addTable", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "editSpace", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "editTable", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "removeSpace", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "removeTable", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "setSpaceSelection", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "createOwner", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "importAssignments", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "assignOwner", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "renameOwner", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "assignOwnerWithName", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "assignOwnerTable", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "setStickersNumberForOwner", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "returnOwner", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "deleteOwner", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "saveNewLayout", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "deleteLayout", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "refreshLayouts", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "refreshSingleLayout", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "saveNewSpaceTag", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "saveNewTableTag", void 0);
    __decorate([
        action
    ], FloorPlanStore.prototype, "updateFloor", null);
    return FloorPlanStore;
}());
export { FloorPlanStore };
//# sourceMappingURL=floorplan.js.map